import {useAuthStore, useValueDataStore} from '@/stores'
import type {MenuItemType} from "@/components/dashboard/sidebar-menu/sidebar.ts";
import type {HubRole} from "@/data";

export class RoleService {

    public getRoles(): string[] {
        const { authRoles } = useAuthStore();
        const { uiRoles } = useValueDataStore();

        return [...uiRoles, ...authRoles];
    }

    public hasRoleForMenuItem(item: MenuItemType): boolean {
        const roles = this.getRoles() as string[];

        if (!roles) {
            return false;
        }
        if (!item.role) {
            return true;
        }

        if (typeof item.role == "function") {
            return (item.role(roles as HubRole[]));
        } else {
            // if item.role is a string, check if it matches the role
            return roles.includes(item.role);
        }
    }

    public hasRole(role: string): boolean {
        const roles = this.getRoles() as string[];

        if (!roles || !role) {
            return false;
        }

        return roles.includes(role);
    }

}
